import PropTypes from 'prop-types';
import { vars } from '@etg/wings';
import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { ShieldCheck } from '@phosphor-icons/react';

const alwaysIncludedStyle = css`
  ul {
    list-style-position: outside;
    list-style-type: disc;
    padding-left: 1.2rem;
    word-break: break-word;

    [dir='rtl'] & {
      padding-left: 0;
      padding-right: 1.2rem;
    }
  }
`;

const AlwaysIncludedNotification = ({ operatingCarrierCodes }) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const carrierCodesAllowed = p('IbeClient.TravelerDetails.DisplayAlwaysIncluded.Carriers');

  const showAlwaysIncludedNotificationInitial = operatingCarrierCodes.some((cc) =>
    carrierCodesAllowed?.includes(cc),
  );

  return showAlwaysIncludedNotificationInitial ? (
    <Notification
      dataTestId="travelerDetails-alwaysIncluded-TripNotification"
      iconComponent={
        <ShieldCheck color={vars.colors.signal.positive.light} size={20} weight="bold" />
      }
      title={t('Notification.AlwaysIncluded.Header')}
      variant={variants.CONFIRMATION}
    >
      <DangerousHtmlContent
        className={alwaysIncludedStyle}
        content={t('Notification.AlwaysIncluded.Text')}
      />
    </Notification>
  ) : null;
};

AlwaysIncludedNotification.propTypes = {
  operatingCarrierCodes: PropTypes.arrayOf(PropTypes.string),
};

export default AlwaysIncludedNotification;
